import { useAtom } from '@reatom/npm-react'
import { useMedia } from 'react-use'
import { useTheme } from 'styled-components'

import { WalletsBalanceCell } from '@root/entities/wallet/ui/table/column/wallet-balance-cell'
import { useMediaDesktopSmallMaxWidth } from '@root/shared/ui-kit'

import type { WalletModel } from '@root/entities/wallet'

type Props = {
  wallet: WalletModel
}

export const WalletsTableBalanceCell: React.FC<Props> = ({ wallet }) => {
  const [balanceUsd] = useAtom(wallet.totalBalanceUsd)
  const [balanceNative] = useAtom(wallet.totalBalanceNative)

  const small = useMediaDesktopSmallMaxWidth()

  const smallIcon = useMedia(useTheme().desktopSmall.queryMaxWidth, false)

  return (
    <WalletsBalanceCell
      balanceUsd={balanceUsd}
      balanceNative={balanceNative}
      network={wallet.network}
      iconSize={smallIcon ? 12 : 18}
      withSeparator={!small}
    />
  )
}
